import { createIdentity } from 'core_main/api/identity';
import { getStore, updateStore } from 'core_main/store';
import { runListenersForEvent } from 'core_main/globals/events';
import { ON_LOGIN } from 'core/constants';
import { getCurrentCustomerContext } from 'core_main/api/customers';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { fetchCurrentTrackingToken } from 'core_main/api/tracking';
import { handleError } from 'globals/errors';
import { LoginCallbackResponse, LoginParameters } from './types';
import { init } from '../init';
import { createLoginCallbackResponse } from './helpers';

export const login = (parameters?: LoginParameters, cb?) => {
  let identity: Promise<LoginCallbackResponse>;
  if (parameters?.jwtToken) {
    const requestParameters = {
      externalToken: parameters?.jwtToken,
    };
    identity = createIdentity(requestParameters).then((identityResponse) => {
      const callbackResponse = createLoginCallbackResponse(identityResponse);
      updateStore('customerId', callbackResponse.customerId);
      updateStore('externalId', callbackResponse.externalId);
      updateStore('email', callbackResponse.email);
      updateStore('verified', callbackResponse.identified);
      return callbackResponse;
    });
  } else {
    identity = fetchCurrentTrackingToken().then((response) => {
      const store = getStore();
      const customerId = response?.data?.relationships?.customer?.data?.id;
      updateStore('customerId', customerId);
      return {
        customerId,
        identified: !!store.verified,
        externalId: store.externalId,
        email: store.email,
      };
    });
  }
  return identity
    .then((identityResponse) => {
      const store = getStore();
      if (
        Array.isArray(store.settings?.assistantRules) &&
        store.settings?.assistantRules.length > 0 &&
        identityResponse.identified
      ) {
        return getCurrentCustomerContext()
          .catch((error) => {
            if (typeof cb === 'function') cb(null, error);
            runListenersForEvent(ON_LOGIN, null, error);
            handleError(error, {
              message: 'Failed to get customer context:',
            });
          })
          .then(() => identityResponse);
      }
      return identityResponse;
    })
    .then((callbackResponse) => {
      const callback = () => {
        if (typeof cb === 'function') cb(callbackResponse);
        runListenersForEvent(ON_LOGIN, callbackResponse);
      };
      updateStore('isPubNubConnected', false);
      // continue to call init for backward compatibility if brandId or assistantId are passed
      if (parameters?.brandId || parameters?.assistantId) {
        return init(
          {
            brandId: parameters?.brandId,
            assistantId: parameters?.assistantId,
          },
          callback,
        );
      }
      const { orgId } = getStore();
      return importAndInitializePubNub({
        customerId: callbackResponse.customerId,
        orgId,
        cb: callback,
      }).then(() => callbackResponse);
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      runListenersForEvent(ON_LOGIN, null, error);
      handleError(error, { message: 'Failed to identify customer:' });
    });
};
